import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../api/fetchJson';
import { FORECAST_URL } from '../../../api/endpoints';
import { ForecastEntry } from '../types';

export function useGetForecast(enabled: boolean) {
  const { data, isPending, error } = useQuery({
    enabled,
    queryKey: ['forecast'],
    queryFn: () => fetchJson<ForecastEntry[]>(FORECAST_URL),
  });

  return {
    data,
    isPending,
    error,
  };
}
